export default __webpack_public_path__ + "static/media/first.d08ce066.png";